import React from "react";
import { Link } from "react-router-dom";
import { SpinnerGap } from "@phosphor-icons/react";

/**
 * Eric 2026-07-20 (iter162) — Extrait de VideoDetailPage.js (refactor 2500→).
 *
 * Composants d'état "vide" pour la page de détail vidéo :
 * - `VideoLoadingState` : spinner centré (data en cours de chargement)
 * - `VideoNotFoundState` : message "Vidéo non trouvée" avec lien retour
 *
 * Purement présentationnels — pas de hooks, pas de state.
 */
export const VideoLoadingState = () => (
  <div className="flex items-center justify-center h-64" data-testid="video-detail-loading">
    <SpinnerGap size={32} className="animate-spin text-[#002FA7]" />
  </div>
);

export const VideoNotFoundState = () => (
  <div className="text-center py-16" data-testid="video-detail-not-found">
    <h2 className="text-xl font-semibold">Video non trouvee</h2>
    <Link to="/dashboard" className="text-[#002FA7] hover:underline mt-4 inline-block">Retour</Link>
  </div>
);
